module.exports = __webpack_public_path__ + "media/images/lp/industries/i-population-487b338c02df410ae5d16c7482248455.svg";